var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"arrow-back",attrs:{"color":"primary","flat":""},on:{"click":_vm.onClick}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v("\n  Atras\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }